<template>
  <div class="programs-table-container">
    <!-- Search Bar -->
    <div class="search-section mb-3">
      <div class="search-container">
        <div class="search-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#374957"/>
          </svg>
          <span class="search-label-text">Search</span>
        </div>
        <div class="search-input-wrapper">
          <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z" fill="#9CA3AF"/>
          </svg>
          <input
            v-model="searchQuery"
            type="text"
            class="search-input"
            placeholder="Search program..."
            style="max-width: 540px;"
          />
          <svg
            v-if="searchQuery"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            class="clear-icon"
            @click="searchQuery = ''"
          >
            <path d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z" fill="#9CA3AF"/>
          </svg>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <Button
            type="normal"
            color-type="dark-blue"
            @click="handleAddProgram"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
              <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H10V4H2V18H16V12H18V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3625 9.75 13.0875 9.75C12.8125 9.75 12.5833 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4875 2.4375 13.4625 1.4625C14.4375 0.4875 15.6167 0 17 0H22V5C22 6.38333 21.5125 7.5625 20.5375 8.5375C19.5625 9.5125 18.3833 10 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.0208 5.425 14.0625 5.625C14.1042 5.825 14.1667 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.0625 18.55 4.3375C18.55 4.6125 18.45 4.85 18.25 5.05L15.65 7.65C15.8667 7.75 16.0875 7.83333 16.3125 7.9C16.5375 7.96667 16.7667 8 17 8Z" fill="white"/>
          </svg>
          &nbsp;&nbsp;Add Program
        </Button>
      </div>
    </div>
  </div>

    <!-- Table -->
    <div class="table-wrapper">
      <!-- Table Header -->
      <div class="table-header">
        <div class="th spacer"></div>
        <div class="th program-name">PROGRAM NAME</div>
        <div class="th duration">DURATION</div>
        <div class="th price">RETAIL PRICE</div>
        <div class="th assignees">Assignees</div>
        <div class="th status">Status</div>
        <div class="th actions">ACTIONS</div>
      </div>

      <!-- Table Body -->
      <div class="table-body">
        <div v-for="program in paginatedPrograms" :key="program.id" class="program-row">
          <div class="td spacer"></div>
          <div class="td program-name">{{ program.name }}</div>
          <div class="td duration">{{ formatDuration(program) }}</div>
          <div class="td price">{{ formatPrice(program.price) }}</div>
          <div class="td assignees">{{ program.assigned_patients_count || 0 }}</div>
          <div class="td status">
            <div class="status-badge-wrapper">
              <span class="status-badge" :class="`status-${program.status.toLowerCase()}`">
                {{ getStatusText(program.status) }}
              </span>
            </div>
          </div>
          <div class="td actions">
            <div class="action-buttons-group">
              <button class="action-btn" title="View" @click="handleViewProgram(program)">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 4.875C11.8425 4.875 14.3775 6.4725 15.615 9C14.3775 11.5275 11.8425 13.125 9 13.125C6.1575 13.125 3.6225 11.5275 2.385 9C3.6225 6.4725 6.1575 4.875 9 4.875ZM9 3.375C5.25 3.375 2.0475 5.7075 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C12.75 14.625 15.9525 12.2925 17.25 9C15.9525 5.7075 12.75 3.375 9 3.375ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM9 5.625C7.14 5.625 5.625 7.14 5.625 9C5.625 10.86 7.14 12.375 9 12.375C10.86 12.375 12.375 10.86 12.375 9C12.375 7.14 10.86 5.625 9 5.625Z" fill="#374957"/>
                </svg>
              </button>
              <button class="action-btn" title="Edit Price" @click="handleEditProgramPrice(program)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M8 17H10V16H11C11.55 16 12 15.55 12 15V12C12 11.45 11.55 11 11 11H8V10H12V8H10V7H8V8H7C6.45 8 6 8.45 6 9V12C6 12.55 6.45 13 7 13H10V14H6V16H8V17ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18ZM14 10L16 8L18 10H14ZM18 14.25L16 16.25L14 14.25" fill="#374957"/>
                </svg>
              </button>
              <button class="action-btn action-btn-delete" title="Archive" @click="handleArchiveProgram(program)">
                <img src="@/assets/MyWorkBench/Workflow/delete_button_prefix.svg"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="filteredPrograms.length === 0" class="empty-state">
      <p class="empty-text">No programs found</p>
    </div>

    <!-- Pagination -->
    <MedicationPagination
      :total="filteredPrograms.length"
      :page-size="perPage"
      :current-page="currentPage"
      :page-size-options="[5, 10, 20, 50]"
      @page-change="handlePageChange"
      @page-size-change="handlePageSizeChange"
    />

    <!-- Program Assignee Dialog -->
    <ProgramAssigneeDialog
      v-if="selectedProgram"
      :visible="showAssigneeDialog"
      :program="selectedProgram"
      @close="handleCloseAssigneeDialog"
      @save="handleSaveAssigneeDialog"
      @open-add-assignee="handleOpenAddAssignee"
      @open-edit="handleOpenEdit"
      @assignees-updated="handleAssigneesUpdated"
      @assignees-list-updated="handleAssigneesListUpdated"
    />

    <!-- Edit Program Price Dialog -->
    <EditProgramPriceDialog
      :visible="showPriceDialog"
      :program-id="selectedProgramId"
      :current-price="selectedProgramPrice"
      @update:visible="showPriceDialog = $event"
      @price-updated="handlePriceUpdated"
    />

    <!-- Add New Assignee Dialog -->
    <AddNewAssigneeDialog
      :visible="showAddAssigneeDialog"
      :workflow-id="selectedProgram?.id || ''"
      :existing-patient-ids="existingPatientIds"
      :is-program="true"
      :maximum-enrollment="selectedProgram?.maximum_enrollment || null"
      :current-enrollment="currentNonCompletedCount"
      @close="handleCloseAddAssigneeDialog"
      @success="handleAddAssigneeSuccess"
    />

    <!-- Edit Program Dialog -->
    <EditProgramDialog
      :visible="showEditProgramDialog"
      :program="selectedProgram || {}"
      @close="handleCloseEditProgramDialog"
      @success="handleEditProgramSuccess"
    />

    <!-- Add Program Dialog (placeholder for now) -->
    <!-- TODO: Create AddProgramDialog component similar to workflow -->
  </div>
</template>

<script>
import { getAllProgramsApi, archiveWorkflowApi } from '@/api/workflowManage';
import Button from '@/NewLibrary/Button.vue';
import MedicationPagination from '@/NewLibrary/MedicationPagination.vue';
import ProgramAssigneeDialog from '@/components/workflow/ProgramAssigneeDialog.vue';
import EditProgramPriceDialog from './EditProgramPriceDialog.vue';
import AddNewAssigneeDialog from '@/views/my-workbench-new/workflow/Dialogs/AddNewAssigneeDialog.vue';
import EditProgramDialog from '@/views/my-workbench-new/workflow/Dialogs/EditProgramDialog.vue';
import { notify } from '@/utils/notify';

export default {
  name: 'ProgramsTable',
  components: {
    Button,
    MedicationPagination,
    ProgramAssigneeDialog,
    EditProgramPriceDialog,
    EditProgramDialog,
    AddNewAssigneeDialog,
  },

  data() {
    return {
      programs: [],
      searchQuery: '',
      loading: false,
      currentPage: 1,
      perPage: 10,
      showAssigneeDialog: false,
      selectedProgram: null,
      showPriceDialog: false,
      selectedProgramId: '',
      selectedProgramPrice: '',
      showAddProgramDialog: false,
      showAddAssigneeDialog: false,
      showEditProgramDialog: false,
      currentAssignees: [], // Track assignees from ProgramAssigneeDialog
    };
  },

  computed: {
    existingPatientIds() {
      // Get patient IDs from current assignees
      return this.currentAssignees.map(a => a.id);
    },
    currentNonCompletedCount() {
      // Calculate non-completed assignees count (for enrollment control)
      return this.currentAssignees.filter(a => a.status !== 'completed').length;
    },
    filteredPrograms() {
      if (!this.searchQuery) return this.programs;

      const query = this.searchQuery.toLowerCase();
      return this.programs.filter(program =>
        program.name?.toLowerCase().includes(query) ||
        program.description?.toLowerCase().includes(query)
      );
    },

    paginatedPrograms() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredPrograms.slice(start, end);
    },
  },

  async mounted() {
    await this.loadPrograms();
  },

  methods: {
    async loadPrograms() {
      this.loading = true;
      try {
        const response = await getAllProgramsApi();
        // Filter out draft programs - only show non-draft programs
        this.programs = (response.data || []).filter(program => program.status !== 'draft');
      } catch (error) {
        console.error('Error loading programs:', error);
        notify({
          title: 'Error',
          message: 'Failed to load programs',
          type: 'error',
          showClose: true
        });
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    handlePageSizeChange(size) {
      this.perPage = size;
      this.currentPage = 1;
    },

    formatDuration(program) {
      const settings = program.program_settings;
      if (!settings) return '-';
      
      if (settings.duration_type === 'fixed_dates') {
        return `${settings.start_date} - ${settings.end_date}`;
      } else if (settings.duration_type === 'duration') {
        return `${settings.duration_value} ${settings.duration_unit}`;
      }
      
      return '-';
    },

    formatPrice(price) {
      if (!price) return '$0.00';
      return `$${parseFloat(price).toFixed(2)}`;
    },

    getStatusClass(status) {
      return {
        'status-active': status === 'active',
        'status-expired': status === 'expired',
        'status-inactive': status === 'inactive',
      };
    },

    getStatusText(status) {
      const statusMap = {
        'active': 'Active',
        'expired': 'Expired',
        'inactive': 'Inactive',
        'draft': 'Draft'
      };
      return statusMap[status] || status;
    },

    async handleViewProgram(program) {
      this.selectedProgram = program;
      this.showAssigneeDialog = true;
    },

    async handleEditProgramPrice(program) {
      this.selectedProgramId = program.id;
      this.selectedProgramPrice = program.price || '';
      this.showPriceDialog = true;
    },

    async handleArchiveProgram(program) {
      try {
        const confirmed = await this.$confirm(
          `Are you sure you want to archive "${program.name}"? This action can be undone from the archive.`,
          'Archive Program',
          {
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        );

        if (confirmed) {
          await archiveWorkflowApi(program.id);
          notify({
            title: 'Success',
            message: 'Program archived successfully',
            type: 'success',
            showClose: true
          });
          await this.loadPrograms();
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error archiving program:', error);
          notify({
            title: 'Error',
            message: 'Failed to archive program',
            type: 'error',
            showClose: true
          });
        }
      }
    },

    handleCloseAssigneeDialog() {
      this.showAssigneeDialog = false;
      // Only clear selectedProgram if we're not opening another dialog
      if (!this.showAddAssigneeDialog && !this.showEditProgramDialog) {
        this.selectedProgram = null;
      }
    },

    async handleSaveAssigneeDialog(updatedProgram) {
      // Update the program in the local list with the modified data
      if (updatedProgram) {
        const index = this.programs.findIndex(p => p.id === updatedProgram.id);
        if (index !== -1) {
          this.programs[index] = { ...this.programs[index], ...updatedProgram };
        }
      }
      
      // Optionally reload from API to get fresh data
      await this.loadPrograms();
      
      this.showAssigneeDialog = false;
      this.selectedProgram = null;
    },

    async handlePriceUpdated({ programId, price }) {
      // Update the program price in the local list immediately
      const index = this.programs.findIndex(p => p.id === programId);
      if (index !== -1) {
        this.programs[index].price = price;
      }
      
      // Reset dialog state
      this.showPriceDialog = false;
      this.selectedProgramId = '';
      this.selectedProgramPrice = '';
    },

    handleOpenAddAssignee() {
      // Close ProgramAssigneeDialog and open AddNewAssigneeDialog
      console.log('handleOpenAddAssignee - selectedProgram:', this.selectedProgram);
      console.log('handleOpenAddAssignee - selectedProgram.id:', this.selectedProgram?.id);
      this.showAssigneeDialog = false;
      this.showAddAssigneeDialog = true;
    },

    handleAssigneesUpdated({ programId, assigneeCount }) {
      // Update the assignee count in the local programs list (for table display)
      const program = this.programs.find(p => p.id === programId);
      if (program) {
        program.assigned_patients_count = assigneeCount;
      }
      
      // Also update selectedProgram if it matches
      if (this.selectedProgram && this.selectedProgram.id === programId) {
        this.selectedProgram.assigned_patients_count = assigneeCount;
      }
    },

    handleAssigneesListUpdated({ assignees }) {
      // Store the assignees list from ProgramAssigneeDialog
      // This is used to calculate currentNonCompletedCount for enrollment control
      this.currentAssignees = assignees || [];
    },

    handleOpenEdit() {
      // Close ProgramAssigneeDialog and open EditProgramDialog
      this.showAssigneeDialog = false;
      this.showEditProgramDialog = true;
    },

    handleCloseEditProgramDialog() {
      // Always reopen ProgramAssigneeDialog when EditProgramDialog closes
      this.showEditProgramDialog = false;
      this.showAssigneeDialog = true;
    },

    async handleEditProgramSuccess({ programId, updatedData }) {
      // Reload programs from backend to get the updated data
      await this.loadPrograms();
      
      // Update selectedProgram with the fresh data
      const updatedProgram = this.programs.find(p => p.id === programId);
      if (updatedProgram) {
        this.selectedProgram = updatedProgram;
      }
      
      // Close EditProgramDialog and reopen ProgramAssigneeDialog
      this.showEditProgramDialog = false;
      this.showAssigneeDialog = true;
    },

    handleCloseAddAssigneeDialog() {
      // Always reopen ProgramAssigneeDialog when AddNewAssigneeDialog closes
      this.showAddAssigneeDialog = false;
      this.showAssigneeDialog = true;
    },

    async handleAddAssigneeSuccess({ patients }) {
      // Close AddNewAssigneeDialog and reopen ProgramAssigneeDialog
      this.showAddAssigneeDialog = false;
      this.showAssigneeDialog = true;
      // The ProgramAssigneeDialog will reload assignees and emit assignees-updated event
      // which will update the table count
    },

    handleAddProgram() {
      this.$emit('add-program');
    },

  }
};
</script>

<style scoped>
.programs-table-container {
  background: white;
  padding-top: 16px;
}

/* Search Section */
.search-section {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.search-container {
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: center;
}

.search-label {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 40px;
}

.search-label-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4a4a4a;
  white-space: nowrap;
}

.search-input-wrapper {
  flex: 1;
  position: relative;
  height: 40px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
}

.clear-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
}

.search-input {
  width: 100%;
  height: 100%;
  padding: 8px 40px 8px 40px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #374957;
  background: #FFFFFF;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #004879;
}

.search-input::placeholder {
  color: #9CA3AF;
}


/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-add-program,
.btn-edit-price {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: white;
  white-space: nowrap;
}

.btn-add-program {
  background: #004879;
}

.btn-edit-price {
  background: #52a8d8;
}

.btn-add-program:hover {
  background: #003366;
}

.btn-edit-price:hover {
  background: #4090c0;
}

/* Table */
.table-wrapper {
  margin-bottom: 16px;
}


.table-header {
  display: grid;
  grid-template-columns: 4% 24% 11% 14% 11% 13% 23%;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #374957;
  background: #f9fafb;
  text-transform: uppercase;
}

.th, .td {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.th.program-name, .td.program-name {
  justify-content: flex-start;
  text-align: left;
}

.table-body {
  display: flex;
  flex-direction: column;
}

.program-row {
  display: grid;
  grid-template-columns: 4% 24% 11% 14% 11% 13% 23%;
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
  transition: background 0.2s;
}

.program-row:hover {
  background: #f9fafb;
}

/* Status Badge */
.status-badge-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.status-badge {
  width: 100%;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
}

.status-active {
  background: #d1fae5;
  color: #059669;
}

.status-expired {
  background: #fee2e2;
  color: #dc2626;
}

.status-inactive {
  background: #f3f4f6;
  color: #6b7280;
}

/* Action Buttons Group */
.action-buttons-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 4px;
  transition: background 0.2s;
}

.action-btn:hover {
  background: rgba(0, 72, 121, 0.08);
}

.action-btn-delete:hover {
  background: #fee2e2;
}

/* Empty State */
.empty-state {
  padding: 60px 20px;
  text-align: center;
}

.empty-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #6b7280;
}

</style>
